import { Grid } from "bm-ui-kit";
import type { MosaicMenu, Variant } from "../type";
import { MobileMenuTileItem } from "./MobileMenuTileItem";

interface MobileMenuTileProps {
	menuType: MosaicMenu[];
	variant: Variant;
}

export const MobileMenuTile = ({ menuType, variant }: MobileMenuTileProps) => {
	return (
		<Grid className="p-3" cols={2} gap={1}>
			{menuType.map((item) => (
				<MobileMenuTileItem key={item.title} variant={variant} {...item} />
			))}
		</Grid>
	);
};
